import { type SxProps, Typography } from "@mui/material";

interface Props {
  children: React.ReactNode;
  sx?: SxProps;
  required?: boolean;
}
export const Label: React.FC<Props> = ({ children, sx, required = false }) => {
  return (
    // ラベルと *必須 を同じ flex 行で縦中央に揃える（inline の vertical-align だと端末でガタつく）。
    // 余白・文字スタイルは呼び出し側の sx（mb など）で従来どおり上書きできるよう、この1要素に適用する
    <Typography
      component="div"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        fontWeight: "700",
        lineHeight: 1.5,
        mb: 1,
        ...sx,
      }}
    >
      <span>{children}</span>
      {required && (
        <Typography
          component="span"
          sx={{
            color: "#d32f2f",
            fontWeight: "700",
            fontSize: "0.75em",
            lineHeight: 1,
            flexShrink: 0,
          }}
        >
          *必須
        </Typography>
      )}
    </Typography>
  );
};
